<template>
  <div id="user-list">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          ref="theTable"
          :external-loading="loading"
          :disable-create="true"
          :disable-edit="true"
          :remote-create-item="remoteCreateItem"
          :remote-update-item="remoteUpdateItem"
          :remote-delete-item="remoteDeleteItem"
          :remote-get-item="remoteGetItem"
          :fetch-list="fetchList"
          edit-with="1000px"
          :search-key-word="searchKeyWord"
          :form-config="formConfig"
          :input-configs="inputConfigs"
          :create-params-callback="createParamsCallback"
          @reset="handleReset"
          @openEditDialog="onEditDialog"
        >
        </CRUDTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import { ref, nextTick, onMounted, onUnmounted } from 'vue'
import { createItem, deleteItem, fetchList, getItem, updateItem } from '@/api/receptionMonitor'
import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'
import moment from '@/utils/moment'

export default {
  name: 'Course',
  components: {
    CRUDTable,
  },
  methods: {
    handleReset() {
      console.log('handleReset')
    },
    onEditDialog(action) {
      console.log('action', action)
    },

    createParamsCallback(params) {
      params.orderBy = 'cr_date'
      params.orderDesc = true

      return params
    },
  },

  setup() {
    const loading = ref(false)
    const searchKeyWord = ref('')

    let interval = null
    const theTable = ref(null)

    onMounted(() => {
      interval = setInterval(() => {
        theTable.value.fetchData()

        // nextTick(() => {
        //   // console.log('theTable.value',theTable)
        //   theTable.value.fetchData()
        // })
      }, 5000)
    })

    onUnmounted(() => {
      clearInterval(interval)
    })

    //   const store = useStore()
    // let domainUsers = ref([])
    // store
    //   .dispatch('domainUsers/list', {})
    //   .then(result => {
    //     console.log('domainUsers result', result)
    //     domainUsers = result.items
    //   })
    //   .catch(err => {
    //     console.log('err', err)
    //   })
    //   store
    //     .dispatch('organizations/list', {})
    //     .then(result => {
    //       console.log('organizations result', result)
    //       // orgs = result.items
    //     })
    //     .catch(err => {
    //       console.log('err', err)
    //     })
    const formConfig = {
      title: 'Reception Monitor',
      headers: [
        // { value: 'id', text: 'Id' },
        { value: 'center.code', text: 'Center', sortable: false },
        { value: 'description', text: 'Description', sortable: false },
        { value: 'create_Date', text: 'DateTime', sortable: false },

        // { value: 'actions', text: 'Actions', sortable: false },
      ],
      customColumns: [

        {
          name: 'create_Date',
          callback(create_Date, record) {
            console.log('create_Date', record)
            const value = moment(record.create_Date).format('YYYY-MM-DD HH:mm:ss')

            return value
          },
        },

      ],

      // customColumns: [
      //   {
      //     name: 'domainUserId',
      //     callback(domainUserId) {
      //       // console.log('in domainUsers callback', domainUsers)
      //       if (domainUsers.length > 0) {
      //         let result = domainUsers.find(domainUser => {
      //           return domainUser.id === domainUserId
      //         })
      //         return result.clientAccount + ' (' + result.orgName + ')'
      //       }
      //       return ''
      //     },
      //   },
      // ],
    }

    return {
      searchKeyWord,
      remoteCreateItem: createItem,
      remoteUpdateItem: updateItem,
      remoteDeleteItem: deleteItem,
      remoteGetItem: getItem,
      fetchList,
      icons: {
        mdiSquareEditOutline,
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPlus,
        mdiExportVariant,
        mdiAccountOutline,
      },
      theTable,
      loading,

      // offsetMd: 6
      inputConfigs: [
        //   { md: 12,  propName: 'id', label: 'Id', readonly: true },
        //   {
        //     md: 6,
        //     propName: 'code',
        //     label: 'Code',
        //     type: {
        //       name: 'select',
        //       storeName: 'orgs',
        //       itemText: 'name',
        //     },
        //   },
        { md: 12, propName: 'courseCode', label: 'CourseCode' },
        { md: 12, propName: 'courseName', label: 'CourseName' },
        { md: 12, propName: 'duration', label: 'Duration' },
      ],

      formConfig,
    }
  },
}
</script>

  <style lang="scss">
  @import '@core/preset/preset/apps/user.scss';
  </style>
